import { render, staticRenderFns } from "./banner_config.vue?vue&type=template&id=13160d8d&"
import script from "./banner_config.vue?vue&type=script&lang=js&"
export * from "./banner_config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports